module.exports = __webpack_public_path__ + "static/img/eyeball.01a9c64.svg";


//////////////////
// WEBPACK FOOTER
// ./src/content/about/images/eyeball.svg
// module id = GQOj
// module chunks = 1